import React, { useContext } from 'react';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';

import './StaticPages.scss';
import Topbar from 'components/Topbar';
import Footer from 'components/Footer';
import SuspenseSpinner from 'components/SuspenseSpinner';
import Context from 'utils/Context';

const StaticPage = ({
  pageId,
}) => {
  const context = useContext(Context);
  const { modele, goTo } = context;

  const page = modele.pages && modele.pages[pageId];
  if (!page) {
    return (
      <SuspenseSpinner />
    );
  }
  return (
    <>
      <Container maxWidth={false}>
        <Topbar />
        <Container maxWidth="lg">
          <Button className='seance-btn' color="primary" size="small" variant="contained" onClick={() => goTo('/')}>
            <ArrowBack />
          </Button>
          <div className='rte-content' dangerouslySetInnerHTML={{ __html: page.content }} />
        </Container>
      </Container>
      <Footer />
    </>
  );
};

export default StaticPage;
